
import React from 'react';
import InboxMessageChat from './InboxMessageChat';
import InboxPropertyAnnouncementsList from './InboxPropertyAnnouncementsList';
import InboxSuitesList from './InboxSuitesList';
import InboxServiceRequestsList from './InboxServiceRequestsList';

const InboxListComponents = ({
  selectedItem,
  type,
  onSetAnnouncement,
  announcement,
  searchString,
  onSearch,
  onSelectItem,
  onCloseItem
}) => {  
    switch(type) {
      case "Messages":
        return <InboxMessageChat 
                 selectedItem={selectedItem} 
                 onCloseItem={onCloseItem} 
                 searchString={searchString}
                />;
      case "Announcements":
        return <InboxPropertyAnnouncementsList 
                 selectedItem={selectedItem}
                 onSetAnnouncement={onSetAnnouncement}
                 announcement={announcement}
               />
      case "General":
        return <InboxSuitesList 
                 searchString={searchString} 
                 onSearch={onSearch} 
                 onSelectItem={onSelectItem}
                />
      case "Service Request":
        return <InboxServiceRequestsList
                  searchString={searchString} 
                  onSearch={onSearch} 
                  onSelectItem={onSelectItem}
                />
      default:
        return null;
    }
}

export default InboxListComponents;